import React, { useEffect, useState } from 'react';
import "katex/dist/katex.min.css";
import { Card } from 'primereact/card';
import { Link, useOutletContext, useSearchParams } from 'react-router-dom';
import Podium from '../../components/Podium';
import { SERVER_HOST } from '../../settings';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function PlayersOfTheDay() {
    const [gameMode] = useOutletContext();
    const [playersOfTheDay, setPlayersOfTheDay] = useState([]);

    const [isMobile, setIsMobile] = useState(false);
    // TODO: do it better one day
    useEffect(() => {
        setTimeout(() => {
            var biggerThanMobile = window.matchMedia("(min-width: 768px)");
            const newIsMobile = !biggerThanMobile.matches;
            setIsMobile(newIsMobile);
        }, 0);
    }, [])

    useEffect(() => {
        fetch(`${SERVER_HOST}/playersOfTheDay/${gameMode.key}`).then(data=>data.json()).then(data => {
            setPlayersOfTheDay(data);
        });
    }, [gameMode]);

    const podiumMedalClass = ['quiz-medal__circle--gold', 'quiz-medal__circle--silver', 'quiz-medal__circle--bronze'];
    const podiumStepClasses = ['podium-gold h-52 rounded-top', 'podium-silver h-40 rounded-top-left', 'podium-bronze h-32 rounded-top-right']


    const podiumStep = (index, player = {}) => (
        <div className="relative w-40 z-10">
            <div className="quiz-medal">
                <div className={`quiz-medal__circle ${podiumMedalClass[index]}`}>
                    <span>
                    {index+1}
                    </span>
                </div>
                <div className="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
                <div className="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
                </div>
                {/* Avatar */}
                <a href={`https://www.geoguessr.com/user/${player.userId}`} target='_blank'>
                    <img
                    src={`https://www.geoguessr.com/images/resize:auto:300:300/gravity:ce/plain/pin/${player.fullBodyPath}.png`}
                    alt="Player B"
                    className="podium-avatar absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-20 h-20 object-contain"
                    />
                </a>
                {/* Podium */}
                <div className={`pt-1 px-4 text-center flex flex-col justify-end ${podiumStepClasses[index]}`}>
                <div>
                    <div className="text-lg font-semibold text-blue-800 player-nick">
                        <Link to={`/player/${player.userId}`}>{player.nick}</Link>
                        &nbsp;
                        <img src={`/flags/${player.countryCode}.png`} style={{ width: '24px' }} />
                        </div>
                    {/* <div className="text-sm text-gray-800">+{player.ratingChange} 🔼</div> */}
                    {/* <div className="text-sm">Current: <span className="font-bold">{player.currentRating}</span></div> */}
                    {/* <div className="text-sm">Yesterday: {player.oldRating}</div> */}
                    <div className={`pt-4 font-semibold text-md gap-2`}>
                      <i className={`text-sm pi pi-sort-${player.ratingChange > 0 ? 'up' : 'down'}`}></i>
                      &nbsp;
                      {player.ratingChange}
                      &nbsp;
                      <i className={`text-sm pi pi-sort-${player.ratingChange > 0 ? 'up' : 'down'}`}></i>
                    </div>
                    <div className="pt-3 text-sm">{player.oldRating} <i className="text-sm pi pi-angle-double-right"></i> {player.currentRating}</div>
                    {/* <div className="text-sm">#{player.oldPosition} → #{player.currentPosition}</div> */}
                </div>
            </div>
        </div>
    );

    const podium = (title, playersOfTheDay = []) => (
        <div className={`col-12 gap-3 ${isMobile ? '' : 'flex flex-column-reverse'}`}>
            <Card className={`col-12 ${isMobile ? '' : 'flex flex-column'} align-items-center`} title={title}  style={{height: '100%'}}>
                <div className="flex justify-center items-end mt-32 gap-0 relative col-12 podium" style={{width: '70rem'}}>
                    {podiumStep(1, playersOfTheDay[1])}
                    {podiumStep(0, playersOfTheDay[0])}
                    {podiumStep(2, playersOfTheDay[2])}
                </div>
            </Card>
        </div>
    )

    const playerBodyTemplate = (rowData) => {
      const player = rowData.nick;

      return (
          <Link to={`/player/${rowData.userId}`} className="flex align-items-center gap-2">
              <div className="avatar-wrapper">
                  <div className="avatar">
                      <img className="avatar-img" src={`https://www.geoguessr.com/images/resize:auto:144:144/gravity:ce/plain/pin/${rowData.fullBodyPath}.png`}/>
                  </div>
              </div>
              <span>{player}</span>
          </Link>
      );
  };

  const countryBodyTemplate = (rowData) => {
    return (
        <div className="flex align-items-center gap-2">
            <img src={`../flags/${rowData.countryCode}.png`} style={{ width: '24px' }} />
            <span>{rowData.countryName}</span>
        </div>
    );
  };

    const columns = [
        {field: 'pos', header: 'Pos.'},
        {field: 'nick', header: 'Nick', body: playerBodyTemplate},
        {field: 'countryCode', header: 'Country', body: countryBodyTemplate},
        {field: 'oldPosition', header: 'Previous position'},
        {field: 'currentPosition', header: 'Current position'},
        {field: 'positionChange', header: 'Position change'},
        {field: 'oldRating', header: 'Previous rating'},
        {field: 'currentRating', header: 'Current rating'},
        {field: 'ratingChange', header: 'Ranking change'}
    ];

    const table = (
      <DataTable value={playersOfTheDay.map((x, i)=>({...x, pos: i+1}))} tableStyle={{ minWidth: '50rem' }} stripedRows dataKey="userId">
          {columns.map((col, i) => (
              <Column key={col.field} field={col.field} header={col.header} body={col.body} />
          ))}
      </DataTable>
    );
    const top30Table = (title) => (
      <div className={`col-12 gap-3 ${isMobile ? '' : 'flex flex-column-reverse'}`}>
        <Card className={`col-12 ${isMobile ? '' : 'flex flex-column'} align-items-center`} title={title}  style={{height: '100%'}}>
            <div className="flex justify-center items-end gap-0 relative col-12" style={{width: '70rem'}}>
                {table}
            </div>
        </Card>
    </div>
    );

    return (
      <div>
        {podium(`Top 3 biggest ranking jumps since yesterday:`, playersOfTheDay)}
        {top30Table(`Top 30 biggest ranking jumps since yesterday:`)}
      </div>
  );
}